import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { MatchCard } from './match-card';
import {
    useGetBFAwardsLeaderboardQuery,
    useGetBFAwardsSeasonQuery
} from 'common/store/modules/api/cfs-api';

export const MatchCardVoteFetcher = ({
    matchData,
    seasonPid,
    seasonId,
    modifier,
    playerModalEnabled,
    shouldHidePredicted
}) => {
    const { data: data } = useGetBFAwardsSeasonQuery(
        {
            seasonPid: seasonPid
        },
        {
            skip: !seasonPid
        }
    );

    const matchVotes = useMemo(() => {
        return data?.matchVotes.find(
            (match) => match.matchId === matchData.providerId
        );
    }, [data]);

    const { data: leaderboardData } = useGetBFAwardsLeaderboardQuery(
        { seasonId: seasonPid },
        { skip: !seasonPid }
    );

    return (
        <MatchCard
            voteData={matchVotes}
            matchData={matchData}
            seasonPid={seasonPid}
            seasonId={seasonId}
            modifier={modifier}
            playerModalEnabled={playerModalEnabled}
            leaderboardData={leaderboardData}
            shouldHidePredicted={shouldHidePredicted}
        />
    );
};

MatchCardVoteFetcher.propTypes = {
    matchData: PropTypes.object,
    seasonPid: PropTypes.string,
    seasonId: PropTypes.number,
    modifier: PropTypes.string,
    playerModalEnabled: PropTypes.bool,
    shouldHidePredicted: PropTypes.bool
};
